export default "__VITE_ASSET__CDaGL32D__"